/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: IAdmin } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    isAdmin: currentUser && currentUser.tenantId === 0,
    isTenant: currentUser && currentUser.tenantId !== 0,
    isTenantAdmin:
      currentUser && currentUser.tenantId !== 0 && currentUser.type === 1,
    isTenantData:
      currentUser && currentUser.tenantId !== 0 && currentUser.type === 2,
  };
}
